import { getRestaurantInfo, getRestaurantConfig } from "../services/api";
import { useDispatch, useSelector } from "react-redux";
//import { setTokens } from "../redux/Slices/authSlice";
import { setRestaurant, setError } from "../redux/Slices/restaurantSlice";
import { setRestaurantConfig} from "../redux/Slices/restaurantConfigSlice";
import { setCategories } from "../redux/Slices/categoriesSlice";
import { setMenu } from "../redux/Slices/menuSlice";
//import {store} from "../redux/store";
import { useRefreshToken } from "../Hooks/useRefreshToken";
import { useConfig } from "../App";
import { useCallback } from "react";
import { setRestaurantMetadata } from "../redux/Slices/restaurantMetadataSlice";
export const useRestaurantInfo = () => {
  const cfg = useConfig(); 
  const proxyString = cfg.config.services.PROXY_STRING;
  const restApiString = cfg.config.services.REST_API_STRING;
  const restConfigApiString = cfg.config.services.REST_SYNC_API_STRING;
  const apiUrl = `${proxyString}${restApiString}`;
  const conigApiUrl = `${proxyString}${restConfigApiString}`;
  const sourceHeader = cfg.config.services.API_SOURCE_HEADER;

  const authInfo = useSelector((state) => state.auth);
  const restaurantInfo = useSelector((state) => state.restaurant.restaurantInfo);
  const step = useSelector((state) => state.step.status);
  const restaurantMetadata = useSelector((state) => state.restaurantMetadata.data);

  // check redux 
  const dispatch = useDispatch();
  const { refreshToken } = useRefreshToken();
  //let currentToken =  useSelector((state) => state.auth.accessToken);
  //const currentTokenExpiresAt = store.getState().auth.expiresAt;
  const getrestaurantData = async(accessTokenData,restaurantId) => {
  let currentToken =  accessTokenData.accessToken;
  
  //const refreshTokenSaved = accessTokenData.refreshToken;
  //const userName = accessTokenData.userProfile.username;
  //const currentTokenExpiresAt = accessTokenData.expiresAt;
  //const currentTokenExpiresAt = Date.now() - 1000;
  //const currentTime = Date.now(); 
  // check if accessToken expires 
  // if(currentTime >= currentTokenExpiresAt)
  // {
  //   // if accesstoken expires , call refresh token
  //   const refreshTokenData = await refreshToken(refreshTokenSaved,userName);
  //   currentToken = refreshTokenData.accessToken;  // change access token
  // }
 try{
  const responseData = await getRestaurantInfo(currentToken,restaurantId,apiUrl,sourceHeader);
  // console.log("RESP", responseData);
  const { restaurant_info, categories, menu_items } = responseData;

  //console.log("RESTAURANT DETAILS", restaurantInfo)
    // store in redux 
    dispatch(
      setRestaurant({
        restaurantInfo:restaurant_info,
      })
    );
     dispatch(
      setCategories({
        categories:categories,
      })
    );
    dispatch(
      setMenu({
        menu_items:menu_items,
      })
    );
  }
  catch{
    dispatch(setError("Failed to load restaurant info"));
  }
    //return await restaurantInfo;
  };
  const getRestaurantConfigData = async (accessToken, restaurantId) => {
    try{
      const responseData = await getRestaurantConfig(accessToken, restaurantId, conigApiUrl, sourceHeader);
      dispatch(
        setRestaurantConfig({
        restaurantConfig: responseData,
        })
      );
    }
    catch(err){
      console.error("Failed to get restaurant config data", err);
    }
  }
  const syncRestaurantData = useCallback(async () => {
    if (!restaurantInfo?.id) {
      console.warn("Skipping sync – restaurantInfo not loaded yet");
      return;
    }

    try {
      // console.log("SYNCING RESTAURANT DATA");
      // console.log("restaurant info before sync", restaurantInfo);

      const currentTime = Date.now();
      const expiresAtMs = authInfo.expiresAt * 1000;

      if (currentTime >= expiresAtMs) {
        // if accesstoken expires , call refresh token
        console.log("Access token expired, refreshing...");
        await refreshToken(authInfo.refreshToken, authInfo.userProfile.username);
      }

      const responseData = await getRestaurantInfo(
        authInfo.accessToken,
        restaurantInfo.id,
        apiUrl,
        sourceHeader
      );

      // update redux store with latest data
      console.log("Updating restaurant metadata after sync");
      dispatch(setRestaurantMetadata(responseData));

      if (step === "idle") {
        // for idle screen, update entire restaurant metadata
        updateRestaurantInfo();
      }

    } catch (err) {
      console.error("Failed to sync restaurant data", err);
    }
  }, [restaurantInfo?.id, authInfo.accessToken]);

  const updateRestaurantInfo = () => {
      const data = restaurantMetadata;

      if (
        data?.restaurant_info &&
        data?.categories &&
        data?.menu_items
      ) {
        console.log("Updating restaurant metadata for idle screen");

        dispatch(setRestaurant({ restaurantInfo: data.restaurant_info }));
        dispatch(setCategories({ categories: data.categories }));
        dispatch(setMenu({ menu_items: data.menu_items }));
      }
  };

  return { getrestaurantData, getRestaurantConfigData, syncRestaurantData, updateRestaurantInfo };
}
